__webpack_require__.p = "/ngrx-functional-effect-factory/referrals-hub/";